<template>
  <path
    d="M19 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018ZM10.71 16.2902C10.32 16.6802 9.69 16.6802 9.3 16.2902L5.71 12.7002C5.32 12.3102 5.32 11.6802 5.71 11.2902C6.1 10.9002 6.73 10.9002 7.12 11.2902L10 14.1702L16.88 7.29018C17.27 6.90018 17.9 6.90018 18.29 7.29018C18.68 7.68018 18.68 8.31018 18.29 8.70018L10.71 16.2902Z"
  />
</template>
